import React, { useEffect, useState } from "react"
import instacartDiscountIcon from "../../../images/instacart_discount_icon.svg"
import phoneIcon from "../../../images/phone-icon.svg"
import calendarIcon from "../../../images/calendar-icon.svg"
import { connect } from "react-redux"
import ApplyPromotionV2 from "../ApplyPromotionV2"
import { Button } from "semantic-ui-react"
import { routerPaths } from "../../../v1/constants/paths"
import { Link, Redirect } from "react-router-dom"
import { PricedAtShop } from "./PricedAtShop"
import { OIL_CHANGE } from "../../../v1/actions/services"
import { withTranslation } from "react-i18next"
import { isDesktop } from "react-device-detect"
import LoadingComponent from "../../../v1/components/LoadingComponent"
import { createOrder } from "../../../v1/actions/orders"
import {
  gaJSON,
  logPurchase,
  orderBookedEvents,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import Notifications from "../../../v1/components/Notifications"
import PaymentMethod from "../../../v1/components/PaymentMethods/PaymentMethod"
import caShortLogo from "../../../images/ca-orange-short.svg"
import { INSTACART, INSTACART_CANADA } from "../../../v1/constants/affiliations"

const ReviewRequest = ({
  cart,
  vehicle,
  activeVehicle,
  createOrder,
  t,
  user,
  braintreePaymentMethods
}) => {
  const [orderId, setOrderId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )
  const sub_total = cart ? cart.estimated_total_pre_tax - cart.transaction_fee : 0
  const order_services = (cart && cart.order_services) || []
  const services =
    order_services.map(function (service) {
      return (
        <div className="row-space-between" style={{ alignItems: "start" }}>
          <div className="service-container">
            <div className="service-name">{service.name}</div>
            {service.position && (
              <div className="service-position">
                {service.reference_id === OIL_CHANGE
                  ? "Manufacturer recommended"
                  : service.position}
              </div>
            )}
          </div>
          {cart && !cart.any_order_service_lacks_price && user && user.country !== "ca" ? (
            <div className="shop-price-est">
              ${Number(service.price_estimate.shop_price_estimate).toFixed(2)}
            </div>
          ) : (
            <div style={{ fontSize: "14px" }}>
              <PricedAtShop />
            </div>
          )}
        </div>
      )
    }) || []

  const onSubmit = async () => {
    setIsSubmitting(true)
    try {
      const response = await createOrder(cart.id)
      const orderId = response.result ? response.result.id : response
      if (orderId) {
        setOrderId(orderId)
        logPurchase(response.result.currency.toUpperCase(), response.result.total)
        await orderBookedEvents({ response, orderId, activeVehicle })
      }
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_preferred_payment,
        params: {
          paymentMethod: cart.payment_type
        }
      })
      setIsSubmitting(false)
    } catch (error) {
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_confirm_service_request_error
      })
    }
  }

  let discountLogo = caShortLogo
  if (isInstacartUser) {
    discountLogo = instacartDiscountIcon
  }

  return (
    <>
      {orderId && <Redirect to={`/appointment-confirm/${orderId}`} />}
      {cart && cart.shop ? (
        <div className="review-request-container">
          {user &&
            user.country !== "ca" &&
            cart &&
            !cart.any_order_service_lacks_price &&
            cart.promotions &&
            cart.promotions.length > 0 && (
              <>
                <div className="discount-banner">
                  <div className="discount-banner-text">
                    <img className="discount-icon" src={discountLogo} />
                    {cart.promotions[0].discount}% {t("oilChangeDiscountApplied")}
                  </div>
                </div>
                <div className="spacer-20" />
              </>
            )}
          <div className="heading-size-18" style={{ fontWeight: 700 }}>
            {t("appointmentDetails")}
          </div>
          <div className="spacer-10" />
          <div className="row-space-between">
            <div className="sub-heading-size-18">{cart.shop ? cart.shop.name : ""}</div>
            <Link
              className="link-text"
              to={routerPaths.shopSelection}
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_selected_shop_review_page
                })
              }}
            >
              {t("change")}
            </Link>
          </div>
          <div className="body-text-16" style={{ color: "#616161" }}>
            {cart.shop ? cart.shop.address_line1 : ""}
          </div>
          {cart.shop && cart.shop.main_phone_number && (
            <a
              href={isDesktop ? null : "tel:" + cart.shop.main_phone_number}
              className="row-flex-start"
            >
              <img src={phoneIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 400
                }}
              >
                {cart.shop.main_phone_number}
              </div>
            </a>
          )}
          <div className="spacer-10" />
          <div className="row-space-between">
            <div className="row-flex-start" style={{ color: "#B83614" }}>
              <img
                src={calendarIcon}
                style={{ paddingRight: "5px", height: "16px", width: "16px" }}
              />
              <div style={{ fontWeight: 500, fontSize: "16px" }}>
                {cart.appointment_date_pretty.split(", ")[1]}
                {", "}
                {cart.appointment_date_pretty.split(", ")[2]} |{" "}
                {cart.is_walk_in || false ? "Walk-in only" : cart.appointment_time_pretty}
              </div>
            </div>
            <Link
              className="link-text"
              to={routerPaths.appointment}
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_appointment_review_page
                })
              }}
            >
              {t("change")}
            </Link>
          </div>
          <div className="spacer-10" />
          <div className="row-flex-start" style={{ fontWeight: 400, fontSize: "14px" }}>
            {vehicle.year || ""} {vehicle.make || ""} {vehicle.model || ""}
          </div>
          <div className="spacer-10" />
          <hr className="hr-solid" />
          <div className="spacer-10" />
          {cart && (cart.any_order_service_lacks_price || (user && user.country === "ca")) && (
            <>
              <div className="priced-at-shop-banner">
                <img className="discount-icon" src={instacartDiscountIcon} />
                <div className="text-block">
                  <span>{t("someShopsPreferToProvideQuotesSpecificToYourVehicleAndNeeds")} </span>
                  <span className="font-bold">
                    {t("youllSeeThePriceAndAnyApplicableDiscountsInTheAppBeforeAnyWorkBegins")}
                  </span>
                </div>
              </div>
              <div className="spacer-20" />
            </>
          )}
          <div>{services}</div>
          <div className="spacer-10" />
          {((user &&
            user.country === "ca" &&
            cart &&
            cart.promotions.length > 0 &&
            cart.promotions[0].discount > 0) ||
            (cart &&
              cart.any_order_service_lacks_price &&
              cart.promotions.length > 0 &&
              cart.promotions[0].discount > 0)) && (
            <>
              <div className="row-space-between">
                {isInstacartUser ? (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <div className="promotional-discount">{t("instacartBenefit")}</div>
                    <img className="discount-icon" src={instacartDiscountIcon} />
                  </div>
                ) : (
                  <div className="promotional-discount">{t("carAdviseBenefit")}</div>
                )}
                <div style={{ color: "#2D765E" }} className="font-bold">
                  {cart.promotions[0].discount}% {t("off")}
                </div>
              </div>
            </>
          )}
          {user && user.country !== "ca" && cart.promotional_discount > 0 && (
            <div className="row-space-between">
              {isInstacartUser ? (
                <div style={{ display: "flex", gap: "10px" }}>
                  <div className="promotional-discount">{t("instacartDiscount")}</div>
                  <img className="discount-icon" src={instacartDiscountIcon} />
                </div>
              ) : (
                <div className="promotional-discount">{t("carAdviseDiscount")}</div>
              )}
              <div className="font-bold" style={{ color: "#282828" }}>
                -${cart?.promotional_discount?.toFixed(2) || ""}
              </div>
            </div>
          )}
          <div className="spacer-10" />
          {((user &&
            user.country === "ca" &&
            user.membership &&
            user.membership.percent_discount &&
            user.membership.percent_discount > 0) ||
            (cart &&
              cart.any_order_service_lacks_price &&
              user &&
              user.membership &&
              user.membership.plan_name !== "Basic" &&
              user.membership.percent_discount > 0)) && (
            <div className="row-space-between">
              <div className="promotional-discount">{t("premiumMembershipBenefit")}</div>
              <div style={{ color: "#2D765E" }} className="font-bold">
                {user.membership.percent_discount}% {t("off")}
              </div>
            </div>
          )}
          {user && user.country !== "ca" && cart && cart.membership_discount > 0 && (
            <div className="row-space-between">
              <div className="promotional-discount">{t("premiumMembershipDiscount")}</div>
              <div className="font-bold" style={{ color: "#282828" }}>
                -${Number(cart.membership_discount).toFixed(2)}
              </div>
            </div>
          )}
          <div className="spacer-20" />
          <ApplyPromotionV2 cart={cart} />
          <div className="spacer-20" />
          <hr className="hr-solid" />
          {user && user.country !== "ca" ? (
            <>
              {cart && !cart.any_order_service_lacks_price && (
                <>
                  <div className="spacer-20" />
                  <div className="row-space-between">
                    <div style={{ color: "#616161" }}>{t("subtotal")}</div>
                    <div className="membership-discount">${Number(sub_total).toFixed(2)}</div>
                  </div>
                </>
              )}
              {cart && !cart.any_order_service_lacks_price && cart.transaction_fee > 0 && (
                <>
                  <div className="spacer-20" />
                  <div className="row-space-between">
                    <div style={{ color: "#616161" }}>{t("convenienceFee")}</div>
                    <div className="membership-discount">${cart.transaction_fee}</div>
                  </div>
                </>
              )}
              {cart && !cart.any_order_service_lacks_price && (
                <>
                  <div className="spacer-20" />
                  <div className="row-space-between">
                    <div style={{ color: "#616161" }}>{t("taxes")}</div>
                    <div className="membership-discount">
                      $
                      {Number(
                        Number(sub_total) * Number(cart.combined_sales_tax_from_service)
                      ).toFixed(2)}
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <></>
          )}
          <div className="spacer-20" />
          <div className="row-space-between estimated-total">
            <div>{t("estimatedTotal")}*</div>
            {user && user.country !== "ca" && cart && !cart.any_order_service_lacks_price ? (
              <div>${cart.estimated_total.toFixed(2)}</div>
            ) : (
              <div style={{ fontSize: "20px" }}>
                <PricedAtShop />
              </div>
            )}
          </div>
          {user && user.country !== "ca" && cart && !cart.any_order_service_lacks_price ? (
            <div className="row-flex-start" style={{ fontWeight: 100, fontSize: "14px" }}>
              *{t("subjectToChangeBasedOnFinalWorkOrder")}
            </div>
          ) : (
            <div
              className="row-flex-start"
              style={{
                fontWeight: 100,
                fontSize: "14px",
                textAlign: "justify",
                lineHeight: "16px"
              }}
            >
              *{t("excludesSalesTaxAndConvenienceFeeWhichWillBeAddedToAllOrders")}
            </div>
          )}
          {user &&
            user.country !== "ca" &&
            cart &&
            !cart.any_order_service_lacks_price &&
            cart.total_savings > 0 && (
              <>
                <div className="spacer-20" />
                <div className="row-space-between" style={{ fontWeight: 500, fontSize: "14px" }}>
                  <div>{t("totalSavings")}</div>
                  <div>${cart?.total_savings?.toFixed(2) || ""}</div>
                </div>
              </>
            )}
          {(braintreePaymentMethods?.length > 0 || false) && (
            <div className="payment-method-review">
              <PaymentMethod
                key={braintreePaymentMethods[0].token}
                paymentMethod={braintreePaymentMethods[0]}
              />
            </div>
          )}
          <div className="action_button">
            <Button
              fluid
              loading={isSubmitting}
              onClick={onSubmit}
              disabled={(!cart.shop && !cart.appointment_date_pretty) || isSubmitting}
              className="primary-button"
            >
              {t("confirmServiceRequest")}
            </Button>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
    </>
  )
}

function mapStateToProps(state) {
  const user = state.user
  const braintreePaymentMethods = state.paymentMethods.braintreePaymentMethods
  const cart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  return {
    braintreePaymentMethods: braintreePaymentMethods,
    user: state.user,
    cart: cart,
    vehicle: activeVehicle,
    activeVehicle: activeVehicle
  }
}

export default connect(mapStateToProps, {
  createOrder
})(withTranslation("serviceRequest")(ReviewRequest))
